module.exports = __webpack_public_path__ + "0f77dc48d013e8304d9496b02fac7c9f.glb";